import {Model} from './Model';
import {Collection} from './Collection';
import config from 'config';

class Growl extends Model{

  /**
   * The subUrl for this model
   */
  get modelUrl(){ return '/growls'; }

  /**
   */
  get defaults(){
    return {
      type: 'growl'
    };
  }

  dismiss(){
    let userId = FW.store.get('user').get('id');
    $.post(config.API_ROOT + '/users/' + userId + '/growls/' + this.get('id') + '/dismiss', {user_id: userId}).then(() => {
      console.log('dismissed', this.get('id'));
    });
  }

}

class Growls extends Collection{}
Growls.prototype.model = Growl;

Growl.prototype.relations = [];

export {Growl, Growls};
